/* eslint-disable react-hooks/exhaustive-deps */
import { CloseCircleFilled } from "@ant-design/icons";
import { Checkbox, Form, List, Space, Spin, Typography, message } from "antd";
import viVN from "antd/es/locale/vi_VN";
import DividerCustom from "components/_storybooks/DividerCustom";
import SpaceCustom from "components/_storybooks/SpaceCustom";
import CustomModal from "components/CustomModal";
import FormInput from "components/FormInput";
import { DATE_FORMAT, FORM_LAYOUT, INPUT_TYPE } from "config/constants";
import { useCities, useWards } from "hooks/common";
import { useSetDeliveryDeadline } from "hooks/order";
import { useApproveContact, useUpdateSellerContact } from "hooks/seller";
import { t } from "i18next";
import moment from "moment";
import { ORDER_PROMOTION_TYPE } from "pages/App/Order/conts";
import { useEffect, useState } from "react";
import { formatDateTime } from "utils/dateTime";
import { handleSearchSelect, notify, parseIsoDateStringToMoment, validator } from "utils/helperFuncs";
import WarehouseSelect from "../WarehouseSelect";

function ListReasonApproveOrder({
  loadingApprove,
  orderID,
  chatURL,
  preOrder,
  deliveryDeadline,
  form,
  warehouseName,
  warehouseNameID,
  warehouses,
  dataSource,
  setWarehouseID,
  messages,
  seller,
  warehouseBranch,
  potentialCustomer,
  promotionType,
  maxDeliveryDate,
  minDeliveryDate,
  orderData,
  receiverContact,
  paymentMethod,
  onAddressApproved,
  addressApproved,
  setAddressApproved,
  sellerID,
  onFormValuesChange,
  shippingType,
  pickupInfo,
}) {
  const [timeSelected, setTimeSelected] = useState();
  const [formValues, setFormValues] = useState({});
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isDatePickerChanging, setIsDatePickerChanging] = useState(false);
  const [approveAddressVisible, setApproveAddressVisible] = useState(false);
  const [internalAddressApproved, setInternalAddressApproved] = useState(false);
  const isAddressApproved = addressApproved !== undefined ? addressApproved : internalAddressApproved;
  const setAddressApprovedFn = setAddressApproved || setInternalAddressApproved;
  const [warehouseSelected, setWarehouseSelected] = useState({
    label: warehouseName,
    value: warehouseNameID,
    branch: warehouseBranch,
  });
  const [approveAddressForm] = Form.useForm();
  const { handleSetDeliveryDeadline, loading } = useSetDeliveryDeadline();
  const { handleApproveContact } = useApproveContact();
  const { handleUpdateContact } = useUpdateSellerContact();

  const addressInitialValues = {
    ...receiverContact,
    cityID: receiverContact?.ward?.version === "V1" ? null : receiverContact?.city?.id,
    wardID: receiverContact?.ward?.version === "V1" ? null : receiverContact?.ward?.id,
  };

  const handleAddressValuesChange = async (changedValues, allValues) => {
    const values = await approveAddressForm.getFieldsValue();
    if (changedValues?.cityID) {
      approveAddressForm.setFieldsValue({
        ...values,
        wardID: null,
      });
    }
  };

  const handleOpenApproveAddress = () => {
    const cityID =
      receiverContact?.ward?.version === "V1" ? null : receiverContact?.cityID || receiverContact?.city?.id;
    approveAddressForm.setFieldsValue({
      ...receiverContact,
      cityID,
      wardID: receiverContact?.ward?.version === "V1" ? null : receiverContact?.wardID || receiverContact?.ward?.id,
    });
    setApproveAddressVisible(true);
    setApproveCityID(cityID);
  };

  const [approveCityID, setApproveCityID] = useState(
    receiverContact?.ward?.version === "V1" ? null : receiverContact?.cityID || receiverContact?.city?.id
  );
  const { cities } = useCities();
  const { wards } = useWards(approveCityID);

  function handleChangeApproveCity(cityID) {
    approveAddressForm.setFieldsValue({
      wardID: null,
    });
    setApproveCityID(cityID);
  }

  const approveFormFields = [
    {
      formItemOptions: {
        label: t("seller.labelInput.fullName"),
        name: "fullName",
        rules: [
          {
            whitespace: true,
            required: true,
            message: t("seller.validateMessage.fullName"),
          },
        ],
      },
      inputOptions: {
        placeholder: t("seller.placeholderInput.fullName"),
        maxLength: 50,
      },
    },
    {
      formItemOptions: {
        label: t("seller.labelInput.email"),
        name: "email",
        rules: [
          {
            whitespace: true,
            required: false,
            message: t("seller.validateMessage.email"),
          },
          validator({
            type: "email",
          }),
        ],
      },
      inputOptions: {
        placeholder: t("seller.placeholderInput.email"),
        maxLength: 50,
      },
    },
    {
      formItemOptions: {
        label: t("seller.labelInput.telephone"),
        name: "telephone",
        rules: [
          {
            required: true,
            message: t("seller.validateMessage.telephone"),
          },
          validator({
            type: "phone",
          }),
        ],
      },
      inputOptions: {
        placeholder: t("seller.placeholderInput.telephone"),
        maxLength: 10,
      },
    },
    {
      type: INPUT_TYPE.SELECT,
      formItemOptions: {
        label: t("seller.labelInput.cityID"),
        name: "cityID",
        rules: [
          {
            required: true,
            message: t("seller.validateMessage.cityID"),
          },
        ],
      },
      inputOptions: {
        placeholder: t("seller.placeholderInput.cityID"),
        maxLength: 50,
        options: cities?.map(({ id, name }) => ({
          label: name,
          value: id,
        })),
        onChange: (value) => handleChangeApproveCity(value),
        showSearch: true,
        allowClear: true,
        filterOption: (search, option) => handleSearchSelect(search, option),
      },
    },
    {
      type: INPUT_TYPE.SELECT,
      formItemOptions: {
        label: t("seller.labelInput.wardID"),
        name: "wardID",
        rules: [
          {
            required: true,
            message: t("seller.validateMessage.wardID"),
          },
        ],
      },
      inputOptions: {
        placeholder: t("seller.placeholderInput.wardID"),
        maxLength: 50,
        options: wards?.map(({ id, name }) => ({
          label: name,
          value: id,
        })),
        allowClear: true,
        showSearch: true,
        filterOption: (search, option) => handleSearchSelect(search, option),
      },
    },
  ];

  // Kiểm tra xem checkbox "Thời gian giao hàng dự kiến" (value=7) có hiển thị không
  const isDeliveryTimeVisible =
    promotionType === ORDER_PROMOTION_TYPE.GROUP_BUYING_CAMPAIGN ||
    promotionType === ORDER_PROMOTION_TYPE.PRE_ORDER_CAMPAIGN ||
    promotionType === ORDER_PROMOTION_TYPE.AUCTION_CAMPAIGN;

  // Tự động check checkbox "Thời gian giao hàng dự kiến" khi nó visible và có deliveryDeadline
  useEffect(() => {
    if (isDeliveryTimeVisible && form && deliveryDeadline) {
      const currentOptions = form.getFieldValue("options") || [];
      if (!currentOptions.includes(7)) {
        form.setFieldsValue({ options: [...currentOptions, 7] });
      }
    }
  }, [isDeliveryTimeVisible, form, deliveryDeadline]);

  const handleGetWarehouse = (value) => {
    setWarehouseSelected(value);
    setWarehouseID && setWarehouseID(value?.value);
  };

  const renderCheckbox = (value, label, isDisabled) => {
    if (isDisabled) {
      return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
          <Checkbox value={value} disabled style={{ pointerEvents: "none" }} />
          <span>{label}</span>
        </span>
      );
    }
    return <Checkbox value={value}>{label}</Checkbox>;
  };

  const fnSetDeliveryDeadline = async (deadlineValue) => {
    try {
      await handleSetDeliveryDeadline({
        orderID: orderID,
        input: { deadline: parseIsoDateStringToMoment(deadlineValue) },
      })
        .then(() => {
          setTimeSelected(deadlineValue);
          message.success(t("order.approvalOrder.successChangeTime"));
        })
        .catch((error) => {
          message.error(error.message);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const onChange = (value) => {
    if (isDatePickerChanging) {
      fnSetDeliveryDeadline(value);
    }
  };

  const disabledDate = (current) => {
    return current && current < moment().startOf("day");
  };

  const handleChangeClick = (e) => {
    e.preventDefault();
    setShowDatePicker(true);
    setIsDatePickerChanging(true);
  };

  const handleOpenChange = (open) => {
    if (!open) {
      setIsDatePickerChanging(false);
    }
    setShowDatePicker(open);
  };

  const handleApproveAddress = async () => {
    try {
      const values = await approveAddressForm.validateFields();
      await handleUpdateContact({
        id: receiverContact?.id,
        contact: {
          ...values,
          email: values?.email || null,
          sellerID: sellerID,
          isDefault: values?.isDefault || false,
        },
      });
      notify.success({
        message: t("seller.componentAddressList.messageApproveAddressSuccess"),
      });
      setApproveAddressVisible(false);
      setAddressApproved(true);
      onAddressApproved && onAddressApproved();
      if (form) {
        form.setFieldsValue({});
      }
    } catch (err) {
      notify.error({
        message: t("seller.componentAddressList.messageApproveAddressError"),
        description: err?.message,
      });
    }
  };

  const locale = {
    ...viVN,
    DatePicker: {
      ...viVN.DatePicker,
      lang: {
        ...viVN.DatePicker.lang,
        ok: t("order.approvalOrder.confirmChangeDeliveryDeadline"),
      },
    },
  };

  const warehouseOptions = warehouses?.map(({ id, name, branch }) => ({
    value: id,
    label: name,
    branch: branch,
  }));

  const checkboxData = [
    {
      name: "checkbox1",
      title: "1. Thông tin nhận hàng",
      description: (
        <Typography.Text>
          Tài khoản tạo đơn hàng{" "}
          <Typography.Text type="warning" strong>
            {seller?.users?.[0].fullname} | {seller?.users?.[0].email}
          </Typography.Text>{" "}
          đã được liên kết với đại lý {seller?.fullName}.
        </Typography.Text>
      ),
      isHidden: messages?.length,
      errorMessage: "Vui lòng xác nhận kiểm tra thông tin nhận hàng.",
    },
    {
      name: "checkbox2",
      title: "2. Thông tin về giá",
      description: "Đơn giá của đơn hàng đã được kiểm tra. Tôi xác nhận bán với giá này.",
      errorMessage: "Vui lòng xác nhận kiểm tra thông tin về giá.",
    },
    {
      name: "checkbox7",
      title: "3. Thông tin giao hàng và thanh toán",
      description: (
        <Typography.Text>
          Thời gian giao hàng dự kiến:{" "}
          <Typography.Text type="warning" strong>
            {(minDeliveryDate && formatDateTime(minDeliveryDate, DATE_FORMAT)) || "#"} -{" "}
            {(maxDeliveryDate && formatDateTime(maxDeliveryDate, DATE_FORMAT)) || "#"}
          </Typography.Text>
          .
        </Typography.Text>
      ),
      isHidden: !isDeliveryTimeVisible,
      defaultChecked: !!deliveryDeadline,
      disabled: !!deliveryDeadline,
      errorMessage: "Vui lòng xác nhận kiểm tra thông tin giao hàng và thanh toán.",
    },
  ];

  const data = [
    {
      title: "1. Thông tin nhận hàng",
      description: renderCheckbox(
        1,
        <Typography.Text>
          Tài khoản tạo đơn hàng{" "}
          <Typography.Text type="warning" strong>
            {seller?.users?.[0].fullname} | {seller?.users?.[0].email}
          </Typography.Text>{" "}
          đã được liên kết với đại lý {seller?.fullName}.
        </Typography.Text>
      ),
      isHidden: messages?.length,
    },
    {
      title: "2. Thông tin về giá",
      description: renderCheckbox(2, "Đơn giá của đơn hàng đã được kiểm tra. Tôi xác nhận bán với giá này."),
    },
    // {
    //   title: renderCheckbox(3, "Thời gian giao hàng dự kiến"),
    //   description: (
    //     <Typography.Text>
    //       Thời gian giao hàng dự kiến: <span style={{ color: "#FF9914" }}>10/09/2024 - 20/09/2024</span>.
    //       <br />
    //       Tôi đảm bảo đơn hàng có thể được giao theo như dự kiến.
    //     </Typography.Text>
    //   ),
    // },

    {
      title: "3. Thông tin giao hàng và thanh toán",
      description: renderCheckbox(
        7,
        <Typography.Text>
          Thời gian giao hàng dự kiến:{" "}
          <Typography.Text type="warning" strong>
            {(minDeliveryDate && formatDateTime(minDeliveryDate, DATE_FORMAT)) || "#"} -{" "}
            {(maxDeliveryDate && formatDateTime(maxDeliveryDate, DATE_FORMAT)) || "#"}
          </Typography.Text>
          .
        </Typography.Text>,
        !!deliveryDeadline
      ),
      isHidden: !isDeliveryTimeVisible,
      defaultChecked: !!deliveryDeadline,
    },
    // {
    //   title: renderCheckbox(4, "Hạn chót giao hàng"),
    //   description: (
    //     <Typography.Text>
    //       Hạn chót giao hàng:{" "}
    //       <Typography.Text type="warning">
    //         {(timeSelected && formatDateTime(timeSelected, DATE_TIME_FORMAT3)) ||
    //           (deliveryDeadline && formatDateTime(deliveryDeadline, DATE_TIME_FORMAT3)) ||
    //           "#"}
    //       </Typography.Text>
    //       .{" "}
    //       <Typography.Link style={{ position: "relative" }} underline onClick={handleChangeClick}>
    //         Thay đổi hạn chót
    //         {showDatePicker && (
    //           <div style={{ position: "absolute", opacity: 0 }}>
    //             <ConfigProvider locale={locale}>
    //               <DatePicker
    //                 disabledDate={disabledDate}
    //                 open={showDatePicker}
    //                 showNow={false}
    //                 showTime={{
    //                   format: "HH:mm",
    //                 }}
    //                 onOpenChange={handleOpenChange}
    //                 onChange={onChange}
    //                 style={{ width: 0, height: 0 }}
    //               />
    //             </ConfigProvider>
    //           </div>
    //         )}
    //       </Typography.Link>
    //       <br /> Tôi đảm bảo đơn hàng có thể được giao theo yêu cầu của Đại lý.
    //     </Typography.Text>
    //   ),
    //   isHidden: !deliveryDeadline,
    // },
    // {
    //   title: renderCheckbox(5, "Tiền đặt cọc"),
    //   description: (
    //     <Typography.Text>
    //       Số tiền đặt cọc <span style={{ color: "#FF9914" }}>5,000,000đ</span> đã về tài khoản. Tôi đã kiểm tra thông
    //       tin với kế toán.
    //     </Typography.Text>
    //   ),
    // },
    // {
    //   title: renderCheckbox(6, "Thông tin tồn kho"),
    //   description: (
    //     <Typography.Text>
    //       Đơn hàng đã có sản phẩm đủ tồn kho. Tôi xác nhận có thể gửi hàng từ kho{" "}
    //       <span style={{ color: "#FF9914" }}>
    //         {warehouseSelected?.branch?.name} - {warehouseSelected.label}
    //       </span>
    //       .
    //     </Typography.Text>
    //   ),
    // },
  ];

  return (
    <div style={{ height: "65vh", overflow: "auto" }}>
      <Spin spinning={loading || loadingApprove}>
        <Form
          form={form}
          layout="vertical"
          onValuesChange={(_, allValues) => {
            setFormValues(allValues);
            onFormValuesChange?.(allValues);
          }}
          initialValues={{
            options: [],
            paymentMethod: orderData?.paymentMethod,
            deliveryDeadline: orderData?.deliveryDeadline ? moment(orderData.deliveryDeadline) : undefined,
            warehouseID: warehouseNameID,
          }}
        >
          <div>
            {messages?.length ? (
              <div>
                {seller.approvalStatus === "WAITING_APPROVAL" && (
                  <SpaceCustom>
                    <Typography.Text type="danger">
                      {messages?.[0]?.content}. Vui lòng
                      <Typography.Link
                        underline
                        target="_blank"
                        href={`/potential-customer-list?statuses=${potentialCustomer?.status ?? "NEW"}${
                          potentialCustomer?.id ? `&defaultID=${potentialCustomer.id}` : ""
                        }${potentialCustomer?.email ? `&defaultEmail=${potentialCustomer.email}` : ""}`}
                      >
                        {" "}
                        Duyệt tài khoản!
                      </Typography.Link>
                    </Typography.Text>
                  </SpaceCustom>
                )}
                {seller.approvalStatus === "APPROVED" && (
                  <SpaceCustom>
                    <Typography.Text type="danger">
                      {"Rất tiếc! Không thể duyệt đơn hàng do thông tin đơn hàng không hợp lệ:"}
                    </Typography.Text>
                    <SpaceCustom direction="horizontal" gap={4}>
                      <CloseCircleFilled style={{ color: "red" }} />
                      <Typography.Text>{messages?.[0]?.content}.</Typography.Text>
                    </SpaceCustom>
                    <Typography.Text type="danger">
                      Vui lòng thực hiện
                      <Typography.Link underline target="_blank" href={`/order/${orderID}`}>
                        {" "}
                        Huỷ đơn hàng!
                      </Typography.Link>
                    </Typography.Text>
                  </SpaceCustom>
                )}
              </div>
            ) : (
              <>
                {(formValues?.paymentMethod === "DEBT" || paymentMethod === "DEBT") &&
                  receiverContact?.status === "WAITING_FOR_APPROVAL" &&
                  !isAddressApproved && (
                    <div
                      style={{
                        marginBottom: 16,
                        borderRadius: 4,
                      }}
                    >
                      <Typography.Text strong type="danger">
                        Rất tiếc! Không thể duyệt đơn hàng do địa chỉ giao hàng của đại lý:
                        {` ${seller?.users?.[0].fullname} | ${seller?.users?.[0].email} `}
                        chưa được xác thực thông tin. Vui lòng
                        <a onClick={handleOpenApproveAddress}> duyệt địa chỉ giao hàng</a>
                      </Typography.Text>
                      <br />
                    </div>
                  )}
                <Typography.Text type="warning">
                  Vui lòng xác nhận kiểm tra cho tất cả các tiêu chí duyệt đơn hàng!
                </Typography.Text>
              </>
            )}
          </div>
          <br />
          <List
            dataSource={checkboxData?.filter((item) => !item?.isHidden)}
            renderItem={(item) => (
              <List.Item key={item.name}>
                <SpaceCustom style={{ width: "100%" }}>
                  <DividerCustom fontWeight="bold" children={item.title} margin={0} />
                  <Form.Item
                    name={item.name}
                    valuePropName="checked"
                    initialValue={item.defaultChecked || false}
                    rules={[
                      {
                        validator: (_, value) =>
                          value ? Promise.resolve() : Promise.reject(new Error(item.errorMessage)),
                      },
                    ]}
                    style={{ marginBottom: 0 }}
                  >
                    <Checkbox disabled={item.disabled}>{item.description}</Checkbox>
                  </Form.Item>
                </SpaceCustom>
              </List.Item>
            )}
          />
          <Space direction="vertical" style={{ padding: "8px", width: "100%" }}>
            <WarehouseSelect
              options={warehouseOptions}
              defaultValue={warehouseName}
              dataSource={dataSource}
              onGetValue={handleGetWarehouse}
              warehouseSelected={warehouseSelected}
              orderData={orderData}
              promotionType={promotionType}
              sellerID={sellerID}
            />

            <Space>
              <Typography.Text>{t("order.approvalOrder.negotiate")}:</Typography.Text>
              <Typography.Link href={chatURL} target="_blank">
                {t("order.approvalOrder.contactViaChatwoot")}
              </Typography.Link>
            </Space>
          </Space>
        </Form>
      </Spin>

      {/* Approve Address Modal */}
      <CustomModal
        {...{
          visible: approveAddressVisible,
          centered: true,
          footer: false,
          width: "fit-content",
          title: t("seller.componentAddressList.approveAddress"),
          onCancel: () => setApproveAddressVisible(false),
          onOke: handleApproveAddress,
          okeButtonLabel: t("seller.componentAddressList.approveAddress"),
          disabled: !!messages?.length,
        }}
      >
        <p style={{ textAlign: "center", color: "#EF9351", marginBottom: "16px", maxWidth: "400px" }}>
          {
            "Địa chỉ giao hàng về kho của đại lý đã được cập nhật. Vui lòng kiểm tra và xác nhận lại thông tin này với đại lý trước khi duyệt"
          }
        </p>
        <Form
          form={approveAddressForm}
          {...FORM_LAYOUT}
          onValuesChange={handleAddressValuesChange}
          initialValues={addressInitialValues}
        >
          <div className="add-address-form">
            {approveFormFields.map((field, index) => {
              return <FormInput key={index} {...field} />;
            })}
            <div className="address-input">
              <FormInput
                {...{
                  formItemOptions: {
                    label: t("seller.labelInput.address"),
                    name: "address",
                  },
                  inputOptions: {
                    placeholder: t("seller.placeholderInput.address"),
                    maxLength: 255,
                  },
                }}
              />
              <Form.Item>
                <FormInput
                  {...{
                    type: INPUT_TYPE.CHECK_BOX,
                    formItemOptions: {
                      name: "isDefault",
                      valuePropName: "checked",
                    },
                    inputChildren: t("seller.componentAddressList.setupDefault"),
                  }}
                />
              </Form.Item>
            </div>
          </div>
        </Form>
      </CustomModal>
    </div>
  );
}

export default ListReasonApproveOrder;
